import React from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardFooter from '../components/DashboardFooter';

const IMG_BASE = '/images/Feb18ServerSideRefactorImages/HotScams';

const ExtortionLearnMorePage = () => {
  const navigate = useNavigate();

  const allDigitalScamLinks = [
    { label: 'Phishing \\ Smishing \\ Spoofing', path: '/dashboard/phishing-learn-more' },
    { label: 'Tech Support', path: '/dashboard/tech-support-learn-more' },
    { label: 'Lottery, sweepstake', path: '/dashboard/lottery-sweepstake-learn-more' },
    { label: 'Law enforcement Impersonation', path: '/dashboard/law-enforcement-impersonation-learn-more' },
    { label: 'Government Impersonation', path: '/dashboard/government-impersonation-learn-more' },
    { label: 'Work From Home', path: '/dashboard/work-from-home-learn-more' },
    { label: 'Grandparent', path: '/dashboard/grandparent-learn-more' },
    { label: 'Crypto ATM', path: '/dashboard/crypto-atm-learn-more' },
    { label: 'Funeral', path: '/dashboard/funeral-learn-more' },
  ];

  const allConfidenceScamLinks = [
    { label: 'Pig Butcher ( Crypto )', path: '/dashboard/cryptocurrency-learn-more' },
    { label: 'Catfishing ( Romance )', path: '/dashboard/catfishing-learn-more' },
  ];

  const psaVideos = [
    'Abused in Salt Lake City',
    'No good deed ( Charity)',
    '$700,000– Price of Love',
    'Can happen to me',
    'Scam Red Flags',
    'Scam Red Flags',
    'Grandparent',
    'Grandparent',
    'Tech Support',
    'Phantom Hacker',
  ];

  return (
    <div className="h-full overflow-y-auto bg-white flex flex-col items-center">
      <div className="w-full max-w-[1920px]">

        {/* Spacer */}
        <div className="pt-6" />

        {/* 1. Hero */}
        <div className="px-12 pt-2 pb-6">
          <div className="flex gap-4" style={{ height: '256px' }}>
            <div className="flex items-center px-10" style={{ width: '33%', backgroundColor: '#DA7842' }}>
              <h1 className="text-4xl font-bold text-white leading-tight">
                Extortion
              </h1>
            </div>
            <img
              src={`${IMG_BASE}/HotScamsExtortionHero.jpeg`}
              alt="Extortion"
              className="h-full object-cover"
              style={{ width: '67%' }}
            />
          </div>
        </div>

        {/* 2. What you need to know */}
        <div className="px-12 py-6">
          <h2 className="text-2xl font-bold text-black mb-4">What you need to know</h2>
          <p className="text-black leading-relaxed mb-4">
            Extortion attempts vary widely, but there are a few common indicators of the scam. It is important to remember these extortion scams change to take advantage of current events such as high-profile breaches or new trends involving the Internet to add authenticity.
          </p>
          <p className="text-black leading-relaxed">
            The extortion attempt comes as an email or letter from an unknown party. The recipient's personal information is noted in the email or letter to add a higher degree of intimidation. The recipient is accused of visiting adult websites, cheating on a spouse, or being involved in other compromising situations. The email threatens to send a video or other compromising information to family, friends, coworkers, or social network contacts if the ransom is not paid — typically within 48 hours via Bitcoin.
          </p>
        </div>

        {/* Personal Safety */}
        <div className="px-12 pb-6">
          <h2 className="text-xl font-bold text-black mb-2">Personal safety</h2>
          <p className="text-black leading-relaxed">
            Call the police immediately if you feel there is a danger to yourself or a loved one
          </p>
        </div>

        {/* 3. Three info cards */}
        <div className="px-12 pb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-white p-6 border-l-4" style={{ backgroundColor: '#000000', borderColor: '#808080' }}>
              <h3 className="text-lg font-bold mb-4">01. Victim Impact</h3>
              <p className="text-sm mb-1">. 17,367 victims</p>
              <p className="text-sm mb-3">. $405 Million stolen</p>
              <p className="text-xs text-gray-400 mt-4">
                Source → FBI \\ IC3 2024 IC3 Annual Report
              </p>
            </div>
            <div className="p-6 border-l-4" style={{ backgroundColor: '#DEE9F6', borderColor: '#2E5F7F' }}>
              <h3 className="text-lg font-bold text-black mb-4">02. Warning Signs</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Email from unknown party referencing your personal information.</li>
                <li>Claims of compromising recordings or activity.</li>
                <li>Short payment deadline, typically 48 hours.</li>
                <li>Leaked passwords used to add credibility.</li>
              </ul>
            </div>
            <div className="p-6 border-l-4" style={{ backgroundColor: '#DEE9F6', borderColor: '#2E5F7F' }}>
              <h3 className="text-lg font-bold text-black mb-4">03. Attach Method</h3>
              <ul className="space-y-2 text-black text-sm">
                <li>Calls \\ DM (texting) \\ Email \\ pop up messages \\ Fake website</li>
                <li>Claims of malware installed on your device.</li>
                <li>Payment demanded exclusively in Bitcoin.</li>
              </ul>
            </div>
          </div>
        </div>

        {/* 04. Prevention Tips */}
        <div className="px-12 py-4">
          <div className="py-8 px-12 border-l-4" style={{ backgroundColor: '#35759C', borderColor: '#ADC9E9' }}>
            <h3 className="text-lg font-bold text-white mb-4">04. Prevention Tips</h3>
            <ul className="space-y-2 text-white text-sm leading-relaxed">
              <li>- Do not open emails or attachments from unknown senders. If it contains a password you recognize, change it immediately.</li>
              <li>- Do not pay the ransom. Paying encourages continued extortion and does not guarantee the threats will stop.</li>
              <li>- Use strong, unique passwords for every account and enable two-factor authentication wherever possible.</li>
              <li>- Cover your webcam when not in use and be cautious about what you share online.</li>
              <li>- Report extortion attempts to the FBI's IC3 at www.ic3.gov.</li>
            </ul>
          </div>
        </div>

        {/* 05. FBI PSA Videos */}
        <div className="px-12 py-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch">
            <div className="p-6 border-l-4" style={{ backgroundColor: '#ADC9E9', borderColor: '#2E5F7F' }}>
              <h3 className="text-xl font-bold text-white mb-4">05. FBI PSA Videos</h3>
              <div className="grid grid-cols-2 gap-x-8 gap-y-2 mb-6">
                {psaVideos.map((title, idx) => (
                  <p key={idx} className="text-sm text-white">{title}</p>
                ))}
              </div>
              <div className="flex justify-center">
                <button
                  onClick={() => navigate('/dashboard/av-library/fbi-ic3')}
                  className="px-12 py-3 bg-white text-black text-sm font-medium hover:bg-gray-200 transition-colors"
                >
                  Watch videos
                </button>
              </div>
            </div>
            <div>
              <img
                src={`${IMG_BASE}/HotScamsImageToTheRightOf05FBIVideosNonAssessmentPages.jpeg`}
                alt="FBI PSA"
                className="object-cover w-full h-full"
              />
            </div>
          </div>
        </div>

        {/* Category Footer */}
        <div className="px-12 pb-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 overflow-hidden">
            <div className="p-8" style={{ backgroundColor: '#CA74C7' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Know more</h3>
            </div>
            <div className="p-8" style={{ backgroundColor: '#6093D4' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Digital Scams</h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-1">
                {allDigitalScamLinks.map((scam, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(scam.path)}
                    className="text-left text-sm text-white hover:text-gray-200 py-1"
                  >
                    {scam.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="p-8" style={{ backgroundColor: '#4B7C30' }}>
              <h3 className="text-2xl font-bold text-white mb-4">Confidence Scams</h3>
              <div className="space-y-1">
                {allConfidenceScamLinks.map((scam, idx) => (
                  <button
                    key={idx}
                    onClick={() => navigate(scam.path)}
                    className="block text-left text-sm text-white hover:text-gray-200 py-1"
                  >
                    {scam.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

      </div>
      <DashboardFooter />
    </div>
  );
};

export default ExtortionLearnMorePage;
